export default "__VITE_ASSET__2af7ff17__"